import { isInIframe } from '@widgets/shared/utils/isInIframe'

const MESSENGER_GET_PARENT_URL_MESSAGE_TYPE = 'textmagicGetParentUrl' as const
const MESSENGER_SEND_PARENT_URL_MESSAGE_TYPE = 'textmagicSendParentUrl' as const

interface MessengerGetParentUrlMessage {
  type: typeof MESSENGER_GET_PARENT_URL_MESSAGE_TYPE
}

interface MessengerSendParentUrlMessage {
  type: typeof MESSENGER_SEND_PARENT_URL_MESSAGE_TYPE
  payload: string // url
}

const isMessengerGetParentUrlMessage = (data: any): data is MessengerGetParentUrlMessage => {
  return data?.type === MESSENGER_GET_PARENT_URL_MESSAGE_TYPE
}

const isMessengerSendParentUrlMessage = (data: any): data is MessengerSendParentUrlMessage => {
  return data?.type === MESSENGER_SEND_PARENT_URL_MESSAGE_TYPE
}

export const subscribeAndHandleMessengerGetParentUrlMessages = () => {
  window.addEventListener('message', (event: MessageEvent) => {
    if (isMessengerGetParentUrlMessage(event.data)) {
      event.source?.postMessage(
        { type: MESSENGER_SEND_PARENT_URL_MESSAGE_TYPE, payload: window.location.href },
        {
          targetOrigin: event.origin,
        },
      )
    }
  })
}

export const getParentUrl = async () => {
  if (!isInIframe()) {
    return undefined
  }

  const message = {
    type: MESSENGER_GET_PARENT_URL_MESSAGE_TYPE,
  } satisfies MessengerGetParentUrlMessage

  window.parent.postMessage(message, '*')

  return new Promise<string>((resolve) => {
    const listener = ({ data }: MessageEvent) => {
      if (isMessengerSendParentUrlMessage(data)) {
        resolve(data.payload)
        window.removeEventListener('message', listener)
      }
    }
    window.addEventListener('message', listener)
  })
}
